function toFiniteNumber(value: unknown): number | undefined {
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : undefined;
    }

    if (typeof value === 'string' && value.trim() !== '') {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : undefined;
    }

    return undefined;
}

function extractFromObject(value: Record<string, unknown>): number | undefined {
    return toFiniteNumber(value.Grand_Total);
}

export function extractGrandTotal(value: unknown): number | undefined {
    const direct = toFiniteNumber(value);
    if (direct !== undefined) return direct;

    if (value && typeof value === 'object') {
        return extractFromObject(value as Record<string, unknown>);
    }

    return undefined;
}

export function hasPipelineDefinitionValue(value: unknown): boolean {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') return value.trim().length > 0;
    return true;
}